<template>
  <v-container>
    <h3>Request a password reset link</h3>

    <v-form ref="form" v-model="form_valid" lazy-validation >
      <v-text-field  label="Email" v-model.trim="email" :rules="required_field_rules"/>
      <v-btn color="secondary" class="mt-3 d-block" v-on:click="forgotPasswordClicked">Request Reset</v-btn>
    </v-form>

    <v-snackbar :color="snackbar.color" v-model="snackbar.show" :timeout="7000" >
      {{ snackbar.message }}
      <v-btn text @click="snackbar.show=false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import {firebase} from '@/firebaseInit.js'

export default {
  name: 'resetpassword',
  data: () => ({
    email: null,
    form_valid: true,
    snackbar: { show: false, message: null, color: 'error' },
    required_field_rules: [ v => !!v || 'Required' ],
  }),
  methods: {
    forgotPasswordClicked() {
      if (!this.$refs.form.validate()) return;

      firebase.auth().sendPasswordResetEmail(this.email).then(() => {
        this.snackbar.show = true;
        this.snackbar.message = "Check your email and follow the instructions";
        this.snackbar.color = 'success';
        window.setTimeout(() => { this.$router.push({ name: 'signin' }) }, 7000)
      }).catch(error => {
        this.snackbar.show = true;
        this.snackbar.message = error.message;
        this.snackbar.color = 'error';
      });
    },
  },
}
</script>